<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader ruta="turnos" tipo="table-heading, card, image, table-tfoot"></SkeletonLoader>
    </v-container>
    <v-container v-else>
        <DialogoCard ref="refDialog" :titulo="titulo" :tipo="tipo" :width="ancho" />
        <DialogoCancelar ref="refDialogElim" :tipo="tipo" @eliminarTurno="cancelar" />
        <v-card flat>
            <v-card-title class="text-h5 font-weight-bold">
                <v-icon color="primary" class="mr-3" size="34">mdi-calendar-clock-outline</v-icon>
                Mis turnos
            </v-card-title>
            <div v-if="!nuevoTurno">
                <v-card-text class="py-0 ma-0">
                    <v-alert type="primary" outlined :value="true" dense class="rounded-0"
                        icon="mdi-check-circle-outline" color="secondary">
                        No hay turnos solicitados
                    </v-alert>
                </v-card-text>
                <v-card flat class="rounded-0">
                    <v-card-text class="my-0 py-0">
                        <FormNuevoTurno></FormNuevoTurno>
                    </v-card-text>
                    <v-card-text class="font-weight-regular text-body-1 text-center">
                        <span v-html="formattedAclaracion"></span><br>
                        Horarios de atención: Lunes a Viernes de 08:00 a 16:00 hs.
                    </v-card-text>
                </v-card>
            </div>
            <v-card v-if="nuevoTurno" class="px-3 rounded-0" elevation="0">
                <v-card class="rounded-xl" outlined>
                    <v-card-title class="d-flex primary--text font-weight-bold mx-3"
                        :class="($vuetify.breakpoint.mdAndDown) ? 'text-h6' : 'text-h5'">
                        Próximo turno
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn dark v-bind="attrs" v-on="on" fab color="red" small :loading="loadSkeleton"
                                    class="elevation-0 ml-auto" @click.stop="lanzarDialogoElim">
                                    <v-icon>mdi-delete-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>Cancelar turno</span>
                        </v-tooltip>
                    </v-card-title>
                    <div class="d-flex flex-column justify-center align-center rounded-0 pa-5 pt-0">
                        <v-card-text v-for="(value, key) in filtroTurno" :key="key"
                            class="d-flex flex-row justify-start py-1">
                            <v-icon color="primary" class="mr-2">{{ icon[key] }}</v-icon>
                            <div class="d-flex flex-column font-weight-bold black--text">
                                {{ key.toUpperCase() }}
                            </div>
                            <div class="d-flex flex-column black--text ml-2">
                                {{ value }}
                            </div>
                        </v-card-text>
                    </div>
                </v-card>
            </v-card>
        </v-card>
    </v-container>
</template>


<script>

import { mapGetters, mapActions } from 'vuex'
import FormNuevoTurno from '@/components/forms/FormNuevoTurno.vue'
import DialogoCard from '@/components/dialogos/DialogoCard'
import DialogoCancelar from '@/components/dialogos/DialogoCancelar'
import Alertas from '@/components/alerts/Alertas.vue'
import TurnoCard from '@/components/cards/TurnoCard.vue'
import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue'

export default {
    components: {
        DialogoCancelar,
        DialogoCard,
        Alertas,
        SkeletonLoader,
        FormNuevoTurno
    },
    mounted() {
        this.forceRerender()
    },
    data() {
        return {
            titulo: '',
            tipo: '',
            ancho: '',
            componentKey: 0,
            headers: [
                {
                    text: 'Fecha',
                    align: 'center',
                    sortable: false,
                    value: 'thd_fecha',
                    divider: true,
                },
                {
                    text: 'Hora',
                    align: 'center',
                    sortable: false,
                    value: 'thd_hora',
                    divider: true,
                },
                {
                    text: 'Distrito',
                    align: 'center',
                    sortable: false,
                    value: 'tdi_desdistrito',
                    divider: true,
                },
                {
                    text: 'Direccion',
                    align: 'center',
                    sortable: false,
                    value: 'tdi_direcc',
                    divider: true,
                },
                {
                    text: 'Motivo',
                    align: 'center',
                    sortable: false,
                    value: 'thd_motivo',
                    divider: true,
                },
                {
                    text: 'Acción',
                    align: 'center',
                    sortable: false,
                    value: 'actions',

                },
            ],
            icon: {
                fecha: 'mdi-calendar-outline',
                hora: 'mdi-clock-outline',
                dirección: 'mdi-map-marker-outline',
                sede: 'mdi-home-city-outline',
            },
            aclaracion: "Para atención en Sede Central sita en Calle 10 Nº 690 LA PLATA, no es necesario solicitar un turno. "

        }
    },

    methods: {
        ...mapActions('turnos', ['getTurnosActivos', 'cancelarTurno']),

        lanzarDialogo() {
            this.titulo = 'Solicitar turno'
            this.tipo = 'turno'
            this.ancho = 1080
            this.$refs.refDialog.abrirDialogo()
        },

        lanzarDialogoElim() {
            this.tipo = "turnos"
            this.$refs.refDialogElim.lanzar()
        },
        cancelar() {
            this.cancelarTurno({ thd_id: this.turnosActivos.thd_id, nroafi: this.nroafi })
        },

        // prueba
        forceRerender() {
            this.componentKey += 1;
        },

        formatDate(date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

    },
    computed: {
        ...mapGetters('turnos', ['turnosActivos', 'nuevoTurno']),
        ...mapGetters('auth', ['nroafi', 'loadSkeleton', 'user']),

        filtroTurno() {
            const { thd_fecha, thd_hora, tdi_direcc, tdi_desdistrito } = this.turnosActivos;
            return {
                fecha: this.formatDate(thd_fecha.split(' ')[0]),
                hora: thd_hora,
                dirección: tdi_direcc,
                sede: tdi_desdistrito,
            };
        },
        formattedAclaracion() {
            return this.aclaracion.replace('Sede Central', '<strong>Sede Central</strong>')
                .replace('no', '<strong>no</strong>');
        }
    },
};
</script>
